import Number from './NumberInputForm';
import Text from './TextInputForm';
import Select from './SelectInputForm';
import Checkbox from './CheckboxInputForm';
import Field from './FieldInputForm';
import Switch from './SwitchElem';
import Editor from './EditorInputForm'


export default { Number, Text, Select, Checkbox, Field, Switch, Editor };
